// -----------------------------------------------------------------------
// <copyright file="btn-action.component.ts" company="AntemetA">
//     Copyright (c) AntemetA. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------
import { Input, Directive } from '@angular/core';
import { Size } from '../btn.constants';

@Directive()
export abstract class BtnActionComponent
{
    @Input() btnText: string;
    @Input() btnWidth: string;
    @Input() disabled: boolean;
    @Input() pressed: boolean = false;
    @Input() size: Size = 'medium';
    @Input() cta: () => void;

    onClick ()
    {
        if (this.cta)
        {
            this.cta();
        }
    }

    getClassNames ()
    {
        return {
            [this.size]: true
        };
    }
}
